import store from '@/store';

const getErrorMessage = error => {
  let message = 'Ocorreu um erro inesperado, tente novamente mais tarde.';

  if (error && error.data) {
    message = Array.isArray(error.data) ? error.data[0].message : error.data.message;
  }

  if (error && error.message && typeof error.message === 'string') {
    message = error.message;
  }

  if (error && error.response && error.response.data && error.response.data.message) {
    message = error.response.data.message;
  }

  if (message === 'Sua sess\u00e3o expirou. Fa\u00e7a login novamente.') {
    store.dispatch('endSession', 3500);
  }

  if (message === 'Token n\u00e3o fornecido') {
    store.dispatch('endSession', 1500);
  }

  return message;
};

export default getErrorMessage;
